import { INavLink } from '../../../components/Nav/useGetNavLinks';

export const CustomNavLinksOrder: Record<string, number | undefined> = {};

export enum ClientNavLinksSemantics {}
export const ClientNavLinks: INavLink[] = [];
